import * as THREE from 'three';
import { renderManager } from '../globals.js';
import { marcadoresRutas, buscarArrecife } from "./buscar_arrecife.js";
import { svg } from "../icons.js";


export function getReefsData() {
  return [
    { name: "Colombia Deep", slug: "Colombia-Deep", type: "function" },
    { name: "Colombia Regular", slug: "Colombia-Regular", type: "function" },
    { name: "Palancar Bricks", slug: "Palancar-Bricks", type: "function" },
    { name: "Palancar Caves", slug: "Palancar-Caves", type: "function" },
    { name: "Palancar Gardens", slug: "Palancar-Gardens", type: "function" },
    { name: "Dalila Francesa", slug: "Dalila-Francesa", type: "function" },
    { name: "El Cedral", slug: "El-Cedral", type: "function" },
    { name: "Santa Rosa Wall", slug: "Santa-Rosa-Wall", type: "function" },
    { name: "San Francisco", slug: "San-Francisco", type: "function" }, // Añadido del HTML
    { name: "San Clemente", slug: "San-Clemente", type: "function" },
    { name: "Tunich", slug: "Tunich", type: "function" },               // Añadido del HTML
    { name: "Yucab", slug: "Yucab", type: "function" },
    { name: "Tormentos", slug: "Tormentos", type: "function" },
    { name: "Chankanaab", slug: "Chankanab", type: "function" },
    { name: "C53 Felipe Xicotencatl", slug: "C53-Felipe-Xicotencatl", type: "function" },
    { name: "Paradise", slug: "Paraiso", type: "function" },
    { name: "Villa Blanca", slug: "Villa-Blanca", type: "function" },   // Añadido del HTML
    
    
  ];
}








export function injectReefsPopupStyles() {
  if (document.getElementById("reef-popup-style")) return;

  const style = document.createElement("style");
  style.id = "reef-popup-style";
  style.innerHTML = `
    #reef-popup-overlay {
      position: fixed;
      inset: 0;
      background: rgba(5,15,25,.75);
      backdrop-filter: blur(12px);
      z-index: 999999;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity .25s ease;
    }

    #reef-popup-overlay.show { opacity: 1; }

    .reef-popup {
      background: linear-gradient(180deg,#0b2a44,#061722);
      width: min(92vw,520px);
      max-height: 85vh;
      border-radius: 22px;
      padding: 22px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      transform: scale(.92);
      transition: transform .25s ease;
      box-shadow: 0 30px 80px rgba(0,0,0,.6);
    }

    #reef-popup-overlay.show .reef-popup { transform: scale(1); }

    .reef-close {
      position:absolute;
      top:14px;
      right:18px;
      background:none;
      border:none;
      color:#fff;
      font-size:20px;
      cursor:pointer;
    }

    .reef-logo { width:90px; margin:0 auto; }
    .reef-popup h2 { color:#fff; text-align:center; }

    .reef-search {
      padding:10px 14px;
      border-radius:12px;
      border:none;
      font-size:14px;
    }

    .reef-grid {
      display:grid;
      grid-template-columns:1fr;
      gap:10px;
      overflow-y:auto;
    }

    .reef-card {
      background:rgba(255,255,255,.08);
      padding:14px;
      border-radius:14px;
      color:#fff;
      cursor:pointer;
      transition:.2s;
    }

    .reef-card:hover {
      background:#1ecad3;
      color:#04242a;
      transform:translateY(-2px);
    }

    .reef-card.featured {
      background:linear-gradient(135deg,#ffd166,#ff9f1c);
      color:#2a1600;
      font-weight:700;
    }
  `;
  document.head.appendChild(style);
}





export function createReefsPopupHTML() {



  console.log(marcadoresRutas)


  const reefs = getReefsData();

  return `
    <div class="reef-popup">
      <button class="reef-close">✖</button>
      <img src="https://cozumel-reef-maps.com.mx/Views/Default/img/logo_3.png" class="reef-logo"/>
      <h2>Explore Cozumel Reefs</h2>
      <input class="reef-search" placeholder="Search reef..." />
      <div class="reef-grid">
        ${reefs.map(r => `
          <div class="reef-card ${r.featured ? "featured" : ""}" 
               data-type="${r.type}" 
               data-value="${r.type === 'url' ? r.url : r.slug}">
            ${r.name}
          </div>
        `).join("")}
      </div>
    </div>
  `;
}



export function bindReefsPopupEvents(overlay) {
  const search = overlay.querySelector(".reef-search");
  const cards  = [...overlay.querySelectorAll(".reef-card")];

  search.addEventListener("input", () => {
    const q = search.value.toLowerCase();
    cards.forEach(c =>
      c.style.display = c.textContent.toLowerCase().includes(q)
        ? "flex" // Cambiado a flex para mantener consistencia con los estilos CSS
        : "none"
    );
  });

  cards.forEach(card => {
    card.addEventListener("click", () => {
      const type = card.dataset.type;
      const value = card.dataset.value;

      closeReefsPopup();


       click_busqueda_arrefice(value);

    });
  });

  overlay.querySelector(".reef-close").onclick = closeReefsPopup;
  overlay.onclick = e => e.target === overlay && closeReefsPopup();

  window.addEventListener("keydown", escClose, { once: true });
}




export function openReefsPopup() {
  if (document.getElementById("reef-popup-overlay")) return;

  injectReefsPopupStyles();

  const overlay = document.createElement("div");
  overlay.id = "reef-popup-overlay";
  overlay.innerHTML = createReefsPopupHTML();

  document.body.appendChild(overlay);
  requestAnimationFrame(() => overlay.classList.add("show"));

  bindReefsPopupEvents(overlay);
}

function closeReefsPopup() {
  const overlay = document.getElementById("reef-popup-overlay");
  if (!overlay) return;

  overlay.classList.remove("show");
  setTimeout(() => overlay.remove(), 250);
}

function escClose(e) {
  if (e.key === "Escape") closeReefsPopup();
}




export function initReefsPopup() {
  const btn = document.getElementById("fogButton");
  if (!btn) return;

  btn.innerHTML = "Reefs 🪸";
  btn.addEventListener("click", e => {
    e.stopPropagation();
    openReefsPopup();
  });
}






export function click_busqueda_arrefice(name_reef) {

    const fogMenu = document.getElementById("fogMenu");
    const fogButton = document.getElementById("fogButton");

    if (fogMenu) fogMenu.classList.remove("open");
    if (fogButton) fogButton.innerHTML = `Reefs 🪸`;

    const data = buscarArrecife(name_reef);

    // ==========================
    // ELIMINAR POPUP ANTERIOR
    // ==========================
    const oldPopup = document.getElementById("popup_js");
    if (oldPopup) oldPopup.remove();

    const oldOverlay = document.getElementById("popup_overlay");
    if (oldOverlay) oldOverlay.remove();

    // ==========================
    // OVERLAY (Aislado y sutil)
    // ==========================
    const overlay = document.createElement("div");
    overlay.id = "popup_overlay";

    Object.assign(overlay.style, {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",         
        webkitBackdropFilter: "blur(4px)",
        zIndex: "999999",
    });

    document.body.appendChild(overlay);

    // ==========================
    // POPUP INDEPENDIENTE (Estilos encapsulados)
    // ==========================
    const popup = document.createElement("div");
    popup.id = "popup_js";

    // Base de estilos comunes para cualquier pantalla
    const baseStyles = {
        position: "fixed",
        background: "linear-gradient(135deg, rgba(18, 28, 46, 0.95), rgba(10, 15, 28, 0.98))",
        color: "#f0f4f8",
        padding: "24px",
        boxSizing: "border-box",
        overflowY: "auto",
        zIndex: "1000000",
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
        borderTop: "3px solid #00d2ff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between", // <--- Corregido aquí
        transition: "all 0.3s ease",
    };

    // Función interna para aplicar el diseño responsive de forma aislada
    function aplicarDisenoResponsive() {
        if (window.innerWidth < 768) {
            // Diseño para Pantallas Chicas (Móvil)
            Object.assign(popup.style, baseStyles, {
                bottom: "0",
                left: "0",
                transform: "none",
                width: "100%",
                maxHeight: "40%",
                borderRadius: "20px 20px 0 0",
                boxShadow: "0 -10px 25px rgba(0,0,0,0.5)",
                border: "none",
                borderTop: "3px solid #00d2ff",
            });
        } else {
            // Diseño para Pantallas Grandes (PC / Tablet)
            Object.assign(popup.style, baseStyles, {
                bottom: "40px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "450px",
                maxHeight: "300px",
                borderRadius: "16px",
                boxShadow: "0 15px 35px rgba(0,0,0,0.6)",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                borderTop: "4px solid #00d2ff",
            });
        }
    }

    // Ejecutamos el diseño al crearlo
    aplicarDisenoResponsive();

    // Escuchamos el cambio de pantalla solo mientras el popup exista
    const resizeHandler = () => aplicarDisenoResponsive();
    window.addEventListener("resize", resizeHandler);

    popup.addEventListener("click", (e) => e.stopPropagation());

    // Limpieza total al cerrar
    overlay.addEventListener("click", () => {
        popup.remove();
        overlay.remove();
        window.removeEventListener("resize", resizeHandler); // Evita fugas de memoria
    });

// Asegúrate de definir esto FUERA de la función que construye el popup 
// (o justo antes de usarlo en la misma función).
const buttonStyle = `
    display: inline-block;
    text-align: center;
    padding: 14px 24px;
    background: linear-gradient(135deg, #00d2ff, #0076ff);
    color: white;
    font-size: 15px;
    border-radius: 10px;
    text-decoration: none;
    font-weight: 600;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    margin-top: 20px;
`;

const mapButtonStyle = `
    display: inline-block;
    text-align: center;
    padding: 14px 24px;
    background: #4a5568; 
    color: white;
    font-size: 15px;
    border-radius: 10px;
    text-decoration: none;
    font-weight: 600;
    margin-top: 20px;
    margin-left: 10px;
    transition: background 0.2s;
`;

// Construcción de la URL correctamente usando template literals
// Usamos el formato: https://www.google.com/maps/search/?api=1&query=LAT,LNG
const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${data.location}`;

popup.innerHTML = `
    <div style="margin-bottom: 15px;">
        <h2 style="margin: 0 0 8px 0; font-size: 24px; font-weight: 700; color: #fff; letter-spacing: -0.5px;">
            ${data.nombre_arrefice}
        </h2>
        <div style="display: inline-flex; align-items: center; background: rgba(255,255,255,0.08); padding: 6px 12px; border-radius: 20px;">
            <span style="font-size: 12px; text-transform: uppercase; letter-spacing: 1px; color: #a0aec0; margin-right: 6px; font-weight: bold;">
                Level
            </span>
            <span style="font-size: 14px; font-weight: 600; color: #00d2ff;">
                ${data.level}
            </span>
        </div>
    </div>

    <div style="display: flex; gap: 10px;">
        <a href="${data.url_full_map}" 
           target="_blank" 
           style="${buttonStyle}">
           View Full 3D Reef
        </a>
        
        <a href="${googleMapsUrl}" 
           target="_blank" 
           style="${mapButtonStyle}">
           ${svg.google_maps} Google Maps Location
        </a>
    </div>
`;

    document.body.appendChild(popup);

    // ==========================
    // DIBUJAR RUTA
    // ==========================
    marcar_linea_del_arrecife(data.rutas);

    // ==========================
    // TRANSICIÓN DE CÁMARA
    // ==========================
    const newPos = new THREE.Vector3(
        data.position_camera_x,
        data.position_camera_y,
        data.position_camera_z
    );

    const newTarget = new THREE.Vector3(
        data.target_camera_x,
        data.target_camera_y,
        data.target_camera_z
    );

    const startPos = renderManager.camera.position.clone();
    const startTarget = renderManager.controls.target.clone();

    const duration = 1200;
    const startTime = performance.now();

    function animate() {
        const now = performance.now();
        const t = Math.min((now - startTime) / duration, 1);
        const ease = 1 - Math.pow(1 - t, 3);

        renderManager.camera.position.lerpVectors(startPos, newPos, ease);
        renderManager.controls.target.lerpVectors(startTarget, newTarget, ease);
        renderManager.controls.update();

        if (t < 1) {
            requestAnimationFrame(animate);
        }
    }

    animate();
}




let grupoMarcas = null;

export function marcar_linea_del_arrecife(puntos) {

    // ==========================
    // LIMPIAR MARCAS ANTERIORES
    // ==========================
    if (grupoMarcas) {

        grupoMarcas.children.forEach(obj => {

            obj.geometry?.dispose();

            if (obj.material) {

                if (Array.isArray(obj.material)) {

                    obj.material.forEach(m => m.dispose());

                } else {

                    obj.material.dispose();
                }
            }
        });

        renderManager.scene.remove(grupoMarcas);
    }

    grupoMarcas = new THREE.Group();

    const RADIO_ESFERA = 0.002;
    const OFFSET_ESFERA = 0.01;

    const raycaster = new THREE.Raycaster();

    puntos.forEach((p, index) => {

        const x = parseFloat(p.X);
        const z = parseFloat(p.Z);

        raycaster.set(
            new THREE.Vector3(x, 10, z),
            new THREE.Vector3(0, -1, 0)
        );

        const inter = raycaster.intersectObject(
            renderManager.terrainMesh,
            true
        );

        if (inter.length === 0) return;

        const terrenoY = inter[0].point.y;

        const start = new THREE.Vector3(
            x,
            terrenoY + 0.001,
            z
        );

        const end = new THREE.Vector3(
            x,
            terrenoY + OFFSET_ESFERA,
            z
        );

        const lineGeo =
            new THREE.BufferGeometry()
                .setFromPoints([start, end]);

        const lineMat =
            new THREE.LineBasicMaterial({
                color: 0xff4d88
            });

        const linea =
            new THREE.Line(
                lineGeo,
                lineMat
            );

        grupoMarcas.add(linea);

        const esferaGeo =
            new THREE.SphereGeometry(
                RADIO_ESFERA,
                16,
                16
            );

        const esferaMat =
            new THREE.MeshStandardMaterial({
                color: 0xff4d88
            });

        const esfera =
            new THREE.Mesh(
                esferaGeo,
                esferaMat
            );

        esfera.position.copy(end);

        grupoMarcas.add(esfera);
    });

    renderManager.scene.add(grupoMarcas);
}